.alert.alert-dismissable(class=`alert-${type}`)
  button.close(type="button", data-dismiss="alert", aria-hidden="true") &times;
  if icon
    i(class=`icon-${icon}`)
  |  #{text}
